import { render, staticRenderFns } from "./SpecimenResultView.vue?vue&type=template&id=7a6b4395&scoped=true&"
import script from "./SpecimenResultView.vue?vue&type=script&lang=js&"
export * from "./SpecimenResultView.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenResultView.vue?vue&type=style&index=0&id=7a6b4395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b4395",
  null
  
)

export default component.exports